var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PROD_BASE_URL = "https://manage.rackspace.com";
const DEV_BASE_URL = "https://dev.manage.rackspace.com";
const LOCAL_BASE_URL = "https://local.dev.manage.rackspace.com";
const CSFR_COOKIE_NAMES = {
  LOCAL: "__janus_login_csurf_dev_subdomain__",
  DEV: "__janus_login_csurf_dev__",
  PROD: "__janus_login_csurf_prod__"
};
const CMS_ADMIN = "https://proxy.api.manage.rackspace.com/customer-admin/";
var js_cookie = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(module, exports) {
  (function(factory) {
    var registeredInModuleLoader;
    {
      module.exports = factory();
      registeredInModuleLoader = true;
    }
    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();
      api.noConflict = function() {
        window.Cookies = OldCookies;
        return api;
      };
    }
  })(function() {
    function extend() {
      var i = 0;
      var result = {};
      for (; i < arguments.length; i++) {
        var attributes = arguments[i];
        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }
      return result;
    }
    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
      function api() {
      }
      function set(key, value, attributes) {
        if (typeof document === "undefined") {
          return;
        }
        attributes = extend({
          path: "/"
        }, api.defaults, attributes);
        if (typeof attributes.expires === "number") {
          attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e5);
        }
        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
        try {
          var result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {
        }
        value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
        var stringifiedAttributes = "";
        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }
          stringifiedAttributes += "; " + attributeName;
          if (attributes[attributeName] === true) {
            continue;
          }
          stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
        }
        return document.cookie = key + "=" + value + stringifiedAttributes;
      }
      function get(key, json) {
        if (typeof document === "undefined") {
          return;
        }
        var jar = {};
        var cookies2 = document.cookie ? document.cookie.split("; ") : [];
        var i = 0;
        for (; i < cookies2.length; i++) {
          var parts = cookies2[i].split("=");
          var cookie = parts.slice(1).join("=");
          if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }
          try {
            var name = decode(parts[0]);
            cookie = (converter.read || converter)(cookie, name) || decode(cookie);
            if (json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {
              }
            }
            jar[name] = cookie;
            if (key === name) {
              break;
            }
          } catch (e) {
          }
        }
        return key ? jar[key] : jar;
      }
      api.set = set;
      api.get = function(key) {
        return get(key, false);
      };
      api.getJSON = function(key) {
        return get(key, true);
      };
      api.remove = function(key, attributes) {
        set(key, "", extend(attributes, {
          expires: -1
        }));
      };
      api.defaults = {};
      api.withConverter = init;
      return api;
    }
    return init(function() {
    });
  });
})(js_cookie);
var cookies = js_cookie.exports;
const omit = (obj, keys) => Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)));
const pick = (options, keys = []) => {
  const customOptions = {};
  keys.forEach((o) => {
    customOptions[o] = options[o];
  });
  return customOptions;
};
const isLocal = (env = "") => new RegExp(`/local.${env}`).test(window.location.origin);
const isDev = () => /\/dev\.manage\./.test(window.location.origin);
const isProd = () => /\/manage\./.test(window.location.origin);
const isRacker = (racker) => {
  if (typeof racker === "undefined") {
    return `${window.location.pathname}/`.includes("/racker/");
  }
  return racker;
};
const baseURL = () => {
  if (isLocal("dev")) {
    return DEV_BASE_URL;
  }
  if (isLocal("prod")) {
    return PROD_BASE_URL;
  }
  return window.location.origin;
};
const toQueryString = (params = {}) => {
  const keys = Object.keys(params);
  if (keys.length === 0) {
    return "";
  }
  return "?" + keys.map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join("&");
};
const getURLS = (racker) => {
  const base = baseURL();
  const isARacker = isRacker(racker);
  const audience = isARacker ? "r" : "c";
  return {
    base: () => base,
    proxyTo: (url) => {
      if (!url.startsWith("http")) {
        console.warn(`fabric-session-ui: url (${url}) does not start with "http" is it valid?`);
      }
      return `${base}/ui-proxy/${audience}/${encodeURIComponent(url)}`;
    },
    login: (next = window.location.href) => `${base}/login/${audience}?RelayState=${next}`,
    session: () => `${base}/login/${audience}/session`,
    sessionActivity: () => `${base}/login/${audience}/session-activity`,
    staticPilot: (section = "default") => `https://dlp3xg0a726x4.cloudfront.net/default-headers/${section}.html`,
    pilot: (config) => {
      const pilotHost = featureFlags().pilotTest ? "test.pilot.manage.rackspace.com" : "pilot.manage.rackspace.com";
      return `https://${pilotHost}/v1/cloud/:rackspaceAccountNumber/navigation${toQueryString(config)}`;
    },
    pilotRacker: () => {
      const pilotHost = featureFlags().pilotTest ? "test.pilot.manage.rackspace.com" : "pilot.manage.rackspace.com";
      return `https://${pilotHost}/v1/racker/navigation`;
    },
    rackerDashboard: () => `${base}/dashboard/racker/search`
  };
};
const getCSFRCookieName = () => {
  if (isLocal()) {
    return CSFR_COOKIE_NAMES.LOCAL;
  }
  if (isDev()) {
    return CSFR_COOKIE_NAMES.DEV;
  }
  if (isProd()) {
    return CSFR_COOKIE_NAMES.PROD;
  }
  return CSFR_COOKIE_NAMES.PROD;
};
const getDefaultCredentials = (credentials) => {
  if (credentials) {
    return credentials;
  }
  return isLocal() ? "include" : "same-origin";
};
const redirectOnStatus = (authenticateOnStatuses = [], isRacker2) => (response) => {
  if (authenticateOnStatuses.includes(response.status)) {
    const loginUrl = getURLS(isRacker2).login();
    window.location.replace(loginUrl);
    return Promise.reject();
  }
  return Promise.resolve(response);
};
const DEFAULT_APP_NAME = "fabric-session-ui";
const getAppName = (appName) => {
  return appName || window.location.pathname.split("/")[1] || DEFAULT_APP_NAME;
};
const throttle = (func, timeFrame) => {
  let lastTime = 0;
  return function() {
    const now = new Date();
    if (now - lastTime >= timeFrame) {
      func();
      lastTime = now;
    }
  };
};
const getEnvironment = () => {
  if (isProd())
    return { shortName: "prod", name: "production" };
  if (isLocal())
    return { shortName: "local", name: "local" };
  if (isDev())
    return { shortName: "dev", name: "development" };
};
const unpackDomainId = (domainId = "") => {
  return {
    isDedicated: domainId.startsWith("dedicated:"),
    rackspaceAccountNumber: String(domainId).replace("dedicated:", "")
  };
};
const featureFlags = () => {
  var _a;
  return {
    pilotTest: /pilotTest/i.test((_a = window.location) == null ? void 0 : _a.search)
  };
};
const cookieHeadersForCSFR = (csrfCookieName = getCSFRCookieName()) => {
  const cookieValue = cookies.get(csrfCookieName);
  const isNodeJs = typeof process !== "undefined" && typeof process.version !== "undefined";
  if (!cookieValue && !isNodeJs) {
    console.warn("fabric-session-ui: No CSFR cookie value is present, this can cause requests to fail");
  }
  return csrfCookieName && cookieValue ? { "X-Csrf-Token": cookieValue } : {};
};
const fetchOption = (fetchOptions, customOptions) => {
  const _a = fetchOptions, { headers } = _a, restOfFetchOptions = __objRest(_a, ["headers"]);
  const { appName } = customOptions;
  const prepareHeadersObject = (headers2) => {
    if (headers2 instanceof window.Headers) {
      const headersObj = {};
      headers2.forEach((headerValue, headerName) => {
        headersObj[headerName] = headerValue;
      });
      return headersObj;
    }
    return headers2;
  };
  return __spreadValues({
    credentials: getDefaultCredentials(fetchOptions.credentials),
    method: "GET",
    headers: __spreadValues(__spreadProps(__spreadValues({}, cookieHeadersForCSFR()), {
      "User-Agent": getAppName(appName),
      "Accept": "application/json",
      "Content-Type": "application/json"
    }), prepareHeadersObject(headers) || {})
  }, restOfFetchOptions);
};
const CUSTOM_FETCH_OPTION_NAMES = [
  "racker",
  "cookieNameCSRF",
  "authenticateOnStatusCodes",
  "appName",
  "bypassProxy"
];
const getProxyFetchArgs = (url, options = {}) => {
  const fetchOptions = omit(options, CUSTOM_FETCH_OPTION_NAMES);
  const proxyOptions = pick(options, CUSTOM_FETCH_OPTION_NAMES);
  const { racker } = proxyOptions;
  const isARacker = isRacker(racker);
  const proxyToUrl = proxyOptions.bypassProxy ? url : getURLS(isARacker).proxyTo(url);
  return [proxyToUrl, fetchOption(fetchOptions, proxyOptions)];
};
const proxyFetch = (url, options = {}) => {
  const { racker, authenticateOnStatusCodes = [] } = options;
  const isARacker = isRacker(racker);
  return fetch(...getProxyFetchArgs(url, options)).then(redirectOnStatus(authenticateOnStatusCodes, isARacker));
};
const getSession = (proxyFetchOptions = {}) => {
  const sessionUrl = getURLS(isRacker(proxyFetchOptions.racker)).session();
  return proxyFetch(sessionUrl, __spreadProps(__spreadValues({}, proxyFetchOptions), {
    bypassProxy: true,
    authenticateOnStatusCodes: proxyFetchOptions.authenticateOnStatusCodes || [401, 403]
  })).then((res) => res.json());
};
const addPilotHTMLTo = (element, isRacker2) => (pilot) => {
  const pilotLoadedEvent = isRacker2 ? "pilotRackerNavLoaded" : "pilotGlobalNavLoaded";
  return new Promise((resolve, reject) => {
    if (!element instanceof Node) {
      return reject(new Error("ProgrammingError: A valid DOM element must be provided in order to load and mount Pilot"));
    }
    window.document.addEventListener(pilotLoadedEvent, () => {
      resolve(window.pilot);
    }, { once: true });
    if (element.hasChildNodes()) {
      element.innerHTML = pilot;
    } else {
      element.appendChild(document.createRange().createContextualFragment(pilot));
    }
  });
};
const renderStaticPilot = (element, section) => proxyFetch(getURLS().staticPilot(section), {
  method: "GET",
  headers: {
    "Context-Type": "text/html",
    "Accept": "text/html"
  }
}).then((res) => res.text()).then(addPilotHTMLTo(element));
const renderPilot = (element, config = {}, queryParams = {}) => {
  var _a, _b;
  const theConfig = {
    "primary-nav": { show: (_b = (_a = config["primary-nav"]) == null ? void 0 : _a.show) != null ? _b : false },
    logout: { uri: "/logout/c" }
  };
  return proxyFetch(getURLS().pilot(queryParams), {
    method: "POST",
    body: JSON.stringify(theConfig),
    headers: {
      "Context-Type": "text/html",
      "Accept": "text/html"
    }
  }).then((res) => {
    if (res.status !== 200) {
      throw new Error("Global nav returned with non-200 response, skipping pilot render");
    }
    return res;
  }).then((res) => res.text()).then(addPilotHTMLTo(element));
};
const loadPilot = (element, config, queryParams, fallbackSection) => Promise.race([
  renderPilot(element, config, queryParams),
  new Promise((resolve, reject) => setTimeout(reject, 5e3))
]).catch((error) => {
  console.error("fabric-ui-session: failed to load Pilot", error);
  return renderStaticPilot(element, fallbackSection);
});
const fetchCMSAccount = (domain) => {
  const { isDedicated, rackspaceAccountNumber } = unpackDomainId(domain);
  return proxyFetch(`${CMS_ADMIN}/v3/customer_accounts/${isDedicated ? "MANAGED_HOSTING" : "CLOUD"}/${rackspaceAccountNumber}`).then((res) => {
    if (!res.ok) {
      throw new Error("could not fetch customer account to set pilot context");
    }
    return res.json();
  });
};
const defaultContextConfig = {
  autoCustomerContextResolution: true,
  domainFromURLRegex: /(.*\/racker\/?)([a-z:0-9]+|$)(.*|$)/i,
  keepSubPaths: false,
  changeLocation: (url) => {
    window.location.replace(url);
  },
  changeLocationRemote: (url) => {
    window.location.replace(url);
  },
  onCustomerContextChange: () => {
  },
  fetchCMSAccount
};
const trimRight = (str = "", char = "/") => str.charAt(str.length - 1) === char ? str : `${str}${char}`;
const updatePathWithDomain = (path = "", domain, conf) => {
  const replacer = (match, beforeDomain, oldDomain, afterDomain) => {
    if (!conf.keepSubPaths) {
      afterDomain = "";
    }
    return [
      trimRight(beforeDomain, "/"),
      domain,
      afterDomain,
      window.location.search
    ].join("");
  };
  return path.replace(conf.domainFromURLRegex, replacer);
};
const getDomainFromURL = (conf) => {
  var _a, _b;
  return (_b = (_a = conf.domainFromURLRegex.exec(window.location.pathname)) == null ? void 0 : _a[2]) != null ? _b : "";
};
const PILOT_CUSTOMER_CONTEXT_EVENT = "CustomerContextEvent";
const negotiateCustomerContext = (config = {}) => (pilot) => {
  var _a, _b;
  const conf = __spreadValues(__spreadValues({}, defaultContextConfig), config);
  if (!conf.autoCustomerContextResolution) {
    return Promise.resolve(pilot);
  }
  window.document.addEventListener(PILOT_CUSTOMER_CONTEXT_EVENT, (e = {}) => {
    const redirectTo = updatePathWithDomain(window.location.pathname, pilot.getCustomer().domain, conf);
    let preventDefaultBehavior = false;
    conf.onCustomerContextChange(__spreadProps(__spreadValues({
      fabricUISessionConfig: conf
    }, e), {
      pilot,
      redirectTo,
      preventDefault: () => preventDefaultBehavior = true
    }));
    if (!preventDefaultBehavior && pilot.getCustomer().domain !== getDomainFromURL(conf)) {
      conf.changeLocation(redirectTo);
    }
  }, { passive: true });
  const domainFromURL = (_a = getDomainFromURL(conf)) != null ? _a : "";
  const pilotDomain = (_b = pilot.getCustomer().domain) != null ? _b : "";
  if (domainFromURL === pilotDomain) {
    if (!pilotDomain && !domainFromURL) {
      conf.changeLocationRemote(getURLS().rackerDashboard());
    }
  } else if (!domainFromURL && pilotDomain) {
    conf.changeLocation(updatePathWithDomain(window.location.pathname, pilotDomain, conf));
  } else if (domainFromURL && domainFromURL !== pilotDomain) {
    return fetchCMSAccount(domainFromURL).then((account) => {
      pilot.setCustomer(account.name, domainFromURL);
      return pilot;
    }).catch(() => {
      console.error("fabric-ui-session: could find find valid customer context from URL, unsetting pilot customer context");
      pilot.setCustomer();
      return pilot;
    });
  }
  return Promise.resolve(pilot);
};
const loadRackerPilot = (element, config = {}) => {
  var _a;
  return proxyFetch(getURLS().pilotRacker(), {
    method: "POST",
    body: JSON.stringify(omit(config, Object.keys(defaultContextConfig))),
    headers: {
      "Context-Type": "application/json"
    },
    racker: true,
    authenticateOnStatusCodes: (_a = config == null ? void 0 : config.authenticateOnStatusCodes) != null ? _a : [403, 401]
  }).then((res) => {
    if (res.status !== 200) {
      throw new Error("Racker Global nav returned with non-200 response, skipping pilot render");
    }
    return res;
  }).then((res) => res.text()).then(addPilotHTMLTo(element, true)).then(negotiateCustomerContext(config));
};
class ActivityNotifier {
  constructor({ racker, authenticateOnStatusCodes = [401] } = {}) {
    this.subscriptions = [];
    this.isRacker = isRacker(racker);
    this.authenticateOnStatusCodes = authenticateOnStatusCodes;
    this.duration = 30 * 1e3;
    this.throttledNotification = throttle(this.callKeepAliveEndpoint.bind(this), this.duration);
    this.lastActivity = Date.now();
  }
  subscribe(callback) {
    this.subscriptions.push(callback);
  }
  unsubscribe(callback) {
    this.subscriptions = this.subscriptions.filter((c) => c === callback);
  }
  callKeepAliveEndpoint() {
    const url = getURLS(this.isRacker).sessionActivity();
    return proxyFetch(url, {
      bypassProxy: true,
      racker: this.isRacker,
      authenticateOnStatusCodes: this.authenticateOnStatusCodes
    }).then((res, err) => {
      this.lastActivity = Date.now();
      this.subscriptions.forEach((callback) => callback(res.ok, err));
      return res;
    }).catch((err) => {
    });
  }
  run() {
    document.addEventListener("click", this.throttledNotification);
    document.addEventListener("keyup", this.throttledNotification);
    document.addEventListener("scroll", this.throttledNotification);
  }
  cleanup() {
    document.removeEventListener("click", this.throttledNotification);
    document.removeEventListener("keyup", this.throttledNotification);
    document.removeEventListener("scroll", this.throttledNotification);
  }
}
export { ActivityNotifier, DEV_BASE_URL, LOCAL_BASE_URL, PROD_BASE_URL, addPilotHTMLTo, getEnvironment, getProxyFetchArgs, getSession, getURLS, isDev, isLocal, isProd, isRacker, loadPilot, loadRackerPilot, negotiateCustomerContext, proxyFetch, redirectOnStatus, unpackDomainId };
